import React, { useId } from 'react';
import { useTranslation } from 'react-i18next';
import { useController, useFormContext } from 'react-hook-form';
import TextInput from '@wix/da-ds/pkg/formControls/dsPresets/TextInput';
import { MAX_TITLE_LENGTH } from '../../../../constants';
import { OriginalDeviationFieldName } from '../../types';

interface Props {}

const TitleField: React.FC<Props> = () => {
  const { t } = useTranslation();
  const id = useId();
  const { control, errors } = useFormContext();
  const {
    field: { value, onChange },
  } = useController({ name: OriginalDeviationFieldName.TITLE, control });
  const error = errors[OriginalDeviationFieldName.TITLE];

  return (
    <TextInput
      id={id}
      maxLength={MAX_TITLE_LENGTH}
      label={t('originalDeviationPopup.form.title.label')}
      placeholder={t('originalDeviationPopup.form.title.placeholder')}
      value={value}
      onChange={onChange}
      details={error?.message}
      validationResult={error ? 'error' : undefined}
      autoFocus
      isRequired
      noBottomSpacing
    />
  );
};
TitleField.displayName = 'TitleField';

export default TitleField;
